import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';

export const OrderNumberComponent: React.FunctionComponent<any> = props => {
    const { translate } = useTranslationHook();
    return (
        <>{translate('Art. No.', { ns: 'article-detail' })} <span data-qa="pdp-sku" className="order-number" itemProp="sku">{props.orderNumber}</span></>
    )
}

